import React from 'react';
import classNames from 'classnames/bind';
import { bool, number, string } from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './PaginationShadow.css';

const cx = classNames.bind(styles);
const PaginationShadow = ({
    headerWidth,
    leftAutomationId,
    overflowActive,
    rightAutomationId,
    scrollPosition,
}) => {
    const inViewLastColHeader = scrollPosition === 'scrollRight';
    const inViewFirstColHeader = scrollPosition === 'scrollLeft';
    const firstDivStyle = { left: `${headerWidth}px` };
    if (overflowActive) {
        if (!inViewLastColHeader && !inViewFirstColHeader) {
            return (
                <>
                    <div
                        className={`${cx('shadow', 'rightShadow')} ${dt(['absolute'])}`}
                        data-automation-id={rightAutomationId}
                    />
                    <div
                        className={`${cx('shadow', 'leftShadow')} ${dt(['absolute'])}`}
                        style={firstDivStyle}
                        data-automation-id={leftAutomationId}
                    />
                </>
            );
        }
        if (!inViewFirstColHeader) {
            return (
                <div
                    className={`${cx('shadow', 'leftShadow')} ${dt(['absolute'])}`}
                    style={firstDivStyle}
                    data-automation-id={leftAutomationId}
                />
            );
        }
        if (!inViewLastColHeader) {
            return (
                <div
                    className={`${cx('shadow', 'rightShadow')} ${dt(['absolute'])}`}
                    data-automation-id={rightAutomationId}
                />
            );
        }
    }
    return null;
};

PaginationShadow.propTypes = {
    headerWidth: number,
    leftAutomationId: string,
    overflowActive: bool,
    rightAutomationId: string,
    scrollPosition: string,
};

PaginationShadow.defaultProps = {
    headerWidth: 0,
    leftAutomationId: 'left-shadow',
    overflowActive: true,
    rightAutomationId: 'right-shadow',
    scrollPosition: 'scrollLeft',
};

export default PaginationShadow;
